import React, {Component} from "react";

class SelectByList extends Component {

    componentDidMount = () => {

        const {value, nullable} = this.props;

        if (nullable === false) {
            if (value === 0 || !value) {
                this.selectFirstOption();
            }
        }
    }

    selectFirstOption = () => {

        const {name, itemList} = this.props;

        if (itemList.length > 0) {
            let newValue = this.getFirstOptionId();
            this.props.handleItemSelect({"currentTarget": {"name": name, "value": newValue}});
        }

    }

    getOptions = () => {
        const {
            itemList,
            valueProperty,
            textProperty,
        } = this.props;

        return (
            itemList.map(item => {
                return (
                    <option key={item[valueProperty]} value={item[valueProperty]}>
                        {item[textProperty]}
                    </option>

                );
            })
        )
    }

    getFirstOptionId = () => {
        const {
            itemList,
            valueProperty,
        } = this.props;
        return itemList[0][valueProperty];
    }

    render = () => {

        const {
            itemList,
            itemsMap,
            valueProperty,
            textProperty,
            name,
            label,
            error,
            help,
            handleItemSelect,
            value,
            nullable,
            enterValue,
            table,
            ...rest
        } = this.props;

        return (
            <div className={table ? "" : "form-group"}>
                {label && <label htmlFor={name}>{label}</label>}
                {enterValue === false && (
                    <select
                        className="form-control"
                        name={name}
                        id={name}
                        value={value}
                        onChange={(event) => handleItemSelect(event)}
                        {...rest}
                    >
                        {(nullable === true &&
                            <option value=""/>
                        )}
                        {this.getOptions()}
                    </select>
                )}

                {enterValue === true && (
                    <React.Fragment>
                        <input
                            className="form-control"
                            type="text"
                            list={`my${name}`}
                            name={name}
                            id={name}
                            // value={value}
                            onChange={(event) => handleItemSelect(event)}
                            {...rest}
                        />
                        <datalist id={`my${name}`}>
                            {(nullable === true &&
                                <option value=""/>
                            )}
                            {this.getOptions()}
                        </datalist>
                    </React.Fragment>
                )}

                {help && (
                    <small id={`${name}Help`} className="form-text text-muted">
                        {help}
                    </small>
                )}
                {error && (
                    <div className="alert alert-danger">{error}</div>
                )}
            </div>
        );

    }

}

SelectByList
    .defaultProps = {
    valueProperty: "dbId",
    textProperty: "name",
    nullable: true,
    enterValue: false
};

export default SelectByList;
